import type { IGraphNodeDesign } from "@skilitics/nautilus-core";

import type { DesignerNodeView, GetManifestByTypeId } from "./types/index.ts";

export const isPlaceholderCreate = (getManifest: GetManifestByTypeId) => (typeId: string) =>
  !!getManifest(typeId).terminus.placeholder;

export type IsPlaceholder = ReturnType<typeof isPlaceholderCreate>;

export const isNodeId = (nodeId?: number): nodeId is number => !!nodeId;

type GetComponentOptions = {
  view?: DesignerNodeView;
};

export const getComponentCreate =
  (getManifest: GetManifestByTypeId) =>
  <TDesign extends IGraphNodeDesign, TType extends TDesign["typeId"]>(
    typeId: TType,
    { view }: GetComponentOptions = {},
  ): React.ComponentType<any> | undefined => {
    // ^ explicit type to avoid cannot be named error
    const manifest = getManifest(typeId);
    const { component, components } = manifest.designer;
    return components && view ? (components[view] ?? component) : component;
  };

export type GetComponentByTypeId = ReturnType<typeof getComponentCreate>;
